import createId from "create-id"
import { WATTS, AMPS, VOLTS, KWH } from '../props-types.js'
import { AVG, SUM, MAX, MIN } from '../props-types.js'
import { COLUMS, LINES } from '../props-types.js'
import { LINE1, LINE2, LINE3 } from '../props-types.js'
import { WIDGET } from '../props-types.js'

class Widget{
    constructor(Widget){
        this.id = Widget.id ? Widget.id : createId()
        this.name = Widget.name ? Widget.name : ''
        this.prop = Widget.prop ? Widget.prop : AMPS
        this.type = Widget.type ? Widget.type : AVG
        this.max = Widget.max ? Widget.max : 1000
        this.min = Widget.min ? Widget.min : 0
        this.graph = WIDGET
    }

    get(){
        return{
            id: this.id,
            name: this.name,
            prop: this.prop,
            type: this.type
        }
    }
}

export default Widget